// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__SyvaI","label":"LabeledBox_label__19HuB"};